export const NAMESPACE = 'Content';
export const LOAD_CONTENT = 'Content/LOAD_CONTENT';
export const LOAD_CONTENT_BY_SLUG = 'Content/LOAD_CONTENT_BY_SLUG';
export const LOAD_CONTENT_BY_FILTER = 'Content/LOAD_CONTENT_BY_FILTER';
